import { createAsyncThunk } from '@reduxjs/toolkit';

import { appsApi } from 'src/api/apps';
import { toast } from 'react-toastify';

export const createApp = createAsyncThunk('apps/create-app', async (data, thunkApi) => {
  try {
    const { payload } = data;

    const response = await appsApi.createApp(payload);

    toast(response.data.message, { type: 'success' });

    thunkApi.dispatch(fetchApps({}));

    return response.data;
  } catch (error) {
    console.error('createApp[error]', error);

    return toast(error.response.data.message, { type: 'error' });
  }
});

export const fetchApps = createAsyncThunk('apps/fetch-apps', async (data) => {
  try {
    const response = await appsApi.fetchApps(data);

    return response.data;
  } catch (error) {
    console.error('fetchApps[error]', error);
    return toast(error.response.data.message, { type: 'error' });
  }
});

export const updateApp = createAsyncThunk('apps/update-app', async (data, thunkApi) => {
  try {
    const { id, payload } = data;

    const response = await appsApi.updateApp(id, payload);

    toast(response.data.message, { type: 'success' });

    thunkApi.dispatch(fetchApps({}));

    return response.data;
  } catch (error) {
    console.error('updateApp[error]', error);
    return toast(error.response.data.message, { type: 'error' });
  }
});

export const deleteApp = createAsyncThunk('apps/delete-app', async (data, thunkApi) => {
  try {
    const { id } = data;

    const response = await appsApi.deleteApp(id);

    toast(response.data.message, { type: 'success' });

    thunkApi.dispatch(fetchApps({}));

    return response.data;
  } catch (error) {
    console.error('deleteApp[error]', error);
    return toast(error.response.data.message, { type: 'error' });
  }
});
